import { LinearProgress } from '@mui/material'
import { TopLosersCardLayout } from './TopLosersCardLayout'

export function TopLosersCardSkeleton() {
  return <TopLosersCardLayout content={<LinearProgress />}></TopLosersCardLayout>
}
